import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/catalog";
import { SectionHeading } from "@/components/home/SectionHeading";

export const FAQ = () => (
  <section className="bg-[#F8F5EF] py-16 md:py-24" data-testid="faq">
    <div className="max-w-3xl mx-auto px-6 md:px-12">
      <SectionHeading overline="FAQ" title="Questions, answered" />
      <Accordion type="single" collapsible className="space-y-3">
        {FAQS.map((f, i) => (
          <AccordionItem
            key={i}
            value={`item-${i}`}
            data-testid={`faq-${i}`}
            className="bg-white rounded-2xl px-6 border-none shadow-[0_4px_24px_rgba(111,80,58,0.04)]"
          >
            <AccordionTrigger className="text-left font-heading font-semibold text-[#6F503A] hover:no-underline py-5">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-[#6F503A]/70 leading-relaxed pb-5">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
